/* ==========================================================================
   NSG Framework
   Component: nsg-why-deco-habitat
   Version: 1.0
   ========================================================================== */

(() => {
  'use strict';

  const sections = document.querySelectorAll('.nsg-wdh');

  if (!sections.length) return;

  sections.forEach((section) => {
    const cards = section.querySelectorAll('.nsg-wdh__card');

    cards.forEach((card) => {

      card.addEventListener('mouseenter', () => {
        card.classList.add('is-active');
      });

      card.addEventListener('mouseleave', () => {
        card.classList.remove('is-active');
      });

      card.addEventListener('focusin', () => {
        card.classList.add('is-active');
      });

      card.addEventListener('focusout', () => {
        card.classList.remove('is-active');
      });

    });
  });

})();